<template>
  <v-row>
    <v-col cols="12">
      <server-password :hostingid="hostingid"></server-password>
    </v-col>
  </v-row>
</template>

<script>
import ServerPassword from 'Components/Services/Hosting/Common/ServerPassword'

export default {
  name: 'DServerPassword',
  components: {
    ServerPassword,
  },
  props: {
    hostingid: {
      type: String,
      default: ''
    }
  },
}
</script>
